import {configureStore} from "@reduxjs/toolkit"
import env from "../config/env"
import State from "../models/State"
import requestReducer from "./request"
import textAlignmentReducer from "./text-alignment"
import searchReducer from "./search"
import viewAllModalReducer from "./viewAllModal"
import SeoReducer from "./seoFilters"
import FeaturesReducer from "./feature-switch"
import categoryQuickLinksReducer from "./categoryQuickLinks"
import tabbedFiltersReducer from "./tabbedFilters"
import textReducer from "./text"
import saleReducer from "./sale"
import templateReducer from "./template"
import lazyloadReducer from "./lazyload"
import productSummaryReducer from "./productSummary"
import productSummaryTemplateSettingsReducer from "./productSummaryTemplate"

const {DEVELOPMENT} = env

export const rootReducer = {
    request: requestReducer,
    search: searchReducer,
    textAlignment: textAlignmentReducer,
    viewAllModal: viewAllModalReducer,
    seoFilters: SeoReducer,
    features: FeaturesReducer,
    categoryQuickLinks: categoryQuickLinksReducer,
    tabbedFilters: tabbedFiltersReducer,
    text: textReducer,
    sale: saleReducer,
    template: templateReducer,
    lazyload: lazyloadReducer,
    productSummary: productSummaryReducer,
    productSummaryTemplate: productSummaryTemplateSettingsReducer,
}

type Reducers = typeof rootReducer
type ActionTypes = {
    [K in keyof Reducers]: Parameters<Reducers[K]>[1]
}

export const makeStore = (initialState?: State) => {
    return configureStore<State, ActionTypes[keyof ActionTypes]>({
        reducer: rootReducer,
        devTools: DEVELOPMENT,
        preloadedState: initialState,
    })
}
